import { cn } from '@/lib/cn';
export function GoldenRule({ short, vertical, className }: { short?: boolean; vertical?: boolean; className?: string }) {
  if (vertical) return <span className={cn('filet-vertical', className)} />;
  return <span className={cn(short ? 'filet-court' : 'filet w-full', className)} />;
}
